<div class="container-fluid">
  <div id="header" class="navbar-central">
    <div class="navbar">
      <a href="auth/login"><img src="../../../../../assets/images/base_logo_transparent_background.png" style="width: 150px; height: 23px;"></a>
    </div>

    <div id="infos-right">
      <ul>
        <li><a href="auth/login" class="btn btn-secondary">Entrar</a></li>
        <li><a href="auth/login" class="btn btn-primary">Fale Conosco</a></li>
      </ul>
    </div>
  </div>

  <!-- content -->
  <div class="container-fluid page">
    <div class="search-central">
      
      <h2>Olá, como podemos ajudar você?</h2>
      
      <div class="search-bar"  [formGroup]="searchForm" >
        <input class="form-control"  formControlName="searchtext"  type="text" placeholder="Digite sua dúvida ou uma palavra-chave" (keyup.enter)="send()">
      </div> 

    </div>
  </div>
  <!-- / content -->
</div>


<div class="bg-content-central">
 
  <div class="container">
    <p style="color: #b3b3b3" *ngIf="total > 0">Resultados encontrados: {{total}}</p>
    <div  *ngFor="let item of items">
      <div>
        <a [routerLink]="['/kb/articles', item.id]" class="btn btn-inline">{{item.name}}</a>
        <p>  {{item.text}}</p>
      </div>
    </div>
    <div class="row mt-5" *ngIf="total > 0">
      <nav aria-label="...">
        <ul class="pagination pagination-sm justify-content-center">
          <ngb-pagination [collectionSize]="total" [(page)]="page"[pageSize]="pageSize"  [maxSize]="20"   [rotate]="true"  [boundaryLinks]="true"  (pageChange)="trocarPaginacao($event)"> </ngb-pagination>
        </ul>
      </nav>
    </div>
  </div>
</div>


<footer class="central">
  <h3>Atendimento comercial e suporte</h3>
  <!-- <a href="#" class="btn btn-inline">contato@nfemail.com.br</a> -->
</footer>

